export default __webpack_public_path__ + "static/media/loading-icon.ce1a1e78.svg";